import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import { MatProgressSpinner } from '@angular/material/progress-spinner'

import { MonitoringService } from '../../../core/services/monitoring/monitoring.service'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { LinhaMonitoramentoVm, NoShowBody } from '../../../core/models/monitoring-os.model'

// Data/hora são do fato, não do clique — o operador quase sempre registra depois
// de tentar contato e esperar. Deixar em branco carimba a hora atual.
@Component({
  selector: 'modal-marcar-no-show',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinner,
  ],
  templateUrl: './modal-marcar-no-show.component.html',
  styleUrl: './modal-marcar-no-show.component.scss',
})
export class ModalMarcarNoShowComponent implements OnInit {
  @Output() response = new EventEmitter<boolean>()

  constructor(
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { item: LinhaMonitoramentoVm },
    private dialogRef: MatDialogRef<ModalMarcarNoShowComponent>,
    private monitoringService: MonitoringService,
    private snackbar: SnackbarCustomService,
  ) {}

  form!: FormGroup
  saving = false
  changed = false

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      dataOcorrido: [null],
      horaOcorrido: [''],
      observacao: [''],
    })
  }

  marcar(): void {
    this.saving = true
    const v = this.form.value
    const body: NoShowBody = {}
    if (v.dataOcorrido) body.dataOcorrido = this.formatDate(v.dataOcorrido)
    if (v.horaOcorrido) body.horaOcorrido = v.horaOcorrido
    if (v.observacao) body.observacao = v.observacao

    this.monitoringService.marcarNoShow(this.data.item.codigoOs, body).subscribe({
      next: (res: any) => {
        this.saving = false
        this.changed = true
        this.snackbar.success(res.message ?? 'No-show registrado com sucesso.')
        this.close()
      },
      error: (err: any) => {
        this.saving = false
        this.snackbar.errorRequest(err)
      },
    })
  }

  private formatDate(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0')
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    return `${day}/${month}/${date.getFullYear()}`
  }

  close(): void {
    this.response.emit(this.changed)
    this.dialogRef.close()
  }
}
